<template>
  <nav v-if="visible" class="home-tabbar" :aria-label="$t('frontend.nav.label')">
    <router-link
      v-for="item in items"
      :key="item.path"
      :to="item.path"
      :class="{ 'is-active': isActive(item) }"
    >
      <span class="home-tabbar__icon"><img :src="isActive(item) ? item.activeImage : item.image" :alt="item.label"></span>
      <span>{{ item.label }}</span>
    </router-link>
  </nav>
</template>

<script>
export default {
  data: () => ({
    items: [
      { path: "/Home", image: "https://ik.imagekit.io/nmil2wj2k/syyy.png?updatedAt=1780093708516", activeImage: "https://ik.imagekit.io/nmil2wj2k/%E4%B8%8B%E8%BD%BD%20(16).png?updatedAt=1780093708539", label: "Home", group: ["/Home"] },
      { path: "/Notice", image: "https://ik.imagekit.io/nmil2wj2k/k2a.3750b5b6%20(1).png?updatedAt=1780093708501", activeImage: "https://ik.imagekit.io/nmil2wj2k/%E4%B8%8B%E8%BD%BD%20(31).png?updatedAt=1780093708493", label: "Notifications", group: ["/Notice"] },
      { path: "/Lottery", image: "https://ik.imagekit.io/nmil2wj2k/%E4%B8%8B%E8%BD%BD%20(18).png?updatedAt=1780093708511", activeImage: "https://ik.imagekit.io/nmil2wj2k/%E4%B8%8B%E8%BD%BD%20(9).png?updatedAt=1780093709158", label: "Dating", group: ["/Lottery"] },
      { path: "/Video", image: "https://ik.imagekit.io/nmil2wj2k/%E4%B8%8B%E8%BD%BD%20(17).png?updatedAt=1780093708496", activeImage: "https://ik.imagekit.io/nmil2wj2k/%E4%B8%8B%E8%BD%BD%20(27).png?updatedAt=1780093708480", label: "Videos", group: ["/Video", "/PlayVideo", "/WatchHistory"] },
      { path: "/Mine", image: "https://ik.imagekit.io/nmil2wj2k/%E4%B8%8B%E8%BD%BD%20(26).png?updatedAt=1780093708536", activeImage: "https://ik.imagekit.io/nmil2wj2k/%E4%B8%8B%E8%BD%BD%20(35).png?updatedAt=1780093708485", label: "My Account", group: ["/Mine", "/Setting", "/Infomation", "/Recharge", "/SetPayPassword", "/SetLoginPassword", "/Setbank", "/BindCard", "/BindUsdt", "/Withdraw", "/Personalreport", "/WithdrawRecord", "/GameRecord", "/detail"] }
    ]
  }),
  computed: {
    visible() {
      const hidden = ["/Login", "/Register", "/Language", "/Withdraw", "/WithdrawRecord", "/VoteRecord", "/LegacyHome", "/LegacyMine"];
      return !hidden.includes(this.$route.path);
    }
  },
  methods: {
    isActive(item) {
      return (item.group || [item.path]).includes(this.$route.path);
    }
  }
};
</script>

<style scoped>
.home-tabbar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  align-items: center;
  min-height: 4rem;
  gap: 0.08rem;
  padding: 0.18rem 0.2rem calc(0.16rem + env(safe-area-inset-bottom));
  background: #f8f8fb;
  border-top: 0.06rem solid #e7e3ec;
  box-shadow: 0 -0.05rem 0.42rem rgba(62, 35, 95, 0.1);
}

.home-tabbar a {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.1rem;
  color: #82769e;
  text-decoration: none;
  font-size: 0.5rem;
  line-height: 0.6875rem;
}

.home-tabbar__icon {
  width: 3.32rem;
  height: 2.38rem;
  border-radius: 0.45rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(104, 56, 160, 0.07);
  color: #8558b8;
  transform: translate(0.0625rem, 0.1875rem);
}

.home-tabbar a > span:last-child { transform: translateY(0.1875rem); }
.home-tabbar a:nth-child(n + 2) .home-tabbar__icon { transform: translate(0, 0.1875rem); }
.home-tabbar a:nth-child(2) > span:last-child,
.home-tabbar a:nth-child(3) > span:last-child { transform: translate(0.0625rem, 0.1875rem); }

.home-tabbar__icon img {
  display: block;
  width: 1.75rem;
  height: 1.75rem;
  object-fit: contain;
  filter: brightness(0) saturate(1) invert(27%) sepia(26%) saturate(3735%) hue-rotate(252deg) brightness(86%) contrast(93%);
}

.home-tabbar a.is-active {
  color: #6f3ab2;
  font-weight: 700;
}

.home-tabbar a.is-active .home-tabbar__icon {
  background: #6838a0;
  box-shadow: none;
}

.home-tabbar a.is-active .home-tabbar__icon img { filter: brightness(0) invert(1); }

@media (min-width: 751px) {
  .home-tabbar {
    left: 50%;
    right: auto;
    transform: translateX(-50%);
    width: 30rem;
  }
}
</style>
